import { graphql, Script } from "gatsby";
import React, { useEffect } from "react";
import convertId from "../../utilities/convert-id";
import Content from "../utilities/content";

const CountdownTimer = ({ data }) => {
  useEffect(() => {
    const scriptId = "elfsight-platform-script";
    let script = document.getElementById(scriptId);

    if (!script) {
      // If the script doesn't exist, create and append it
      script = document.createElement("script");
      script.src = "https://static.elfsight.com/platform/platform.js";
      script.async = true;
      script.id = scriptId;
      document.body.appendChild(script);
    }
  });

  return (
    <section
      id={convertId(data.name)}
      className={`section section-countdown-widget ${
        data.backgroundColor === "white" ? "bg-white" : "bg-gray"
      }`}
    >
      <div className="container">
        <div className="content-above">
          <Content className="content-main">{data.contentAbove}</Content>
        </div>
        <div className="countdown-timer overflow-hidden w-100">
          <div
            class="elfsight-app-5819d7ee-ff75-4d65-8cd4-c11003d9664e"
            data-elfsight-app-lazy
          ></div>
        </div>
        <div className="content-below pt-3">
          <Content className="content-main">{data.contentBelow}</Content>
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment CountdownTimer on WpPage_Sections_Sections_CountdownTimer {
    fieldGroupName
    hideSection
    name
    backgroundColor
    contentAbove
    contentBelow
  }
`;

export default CountdownTimer;
